import { Route, Routes } from 'react-router-dom';
import { featureFlags } from '../config/featureFlags';
import AcceptInvitePage from '../pages/AcceptInvitePage';
import ErrorPage from '../pages/ErrorPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import HomePage from '../pages/HomePage';
import LoginPage from '../pages/LoginPage';
import NotFoundPage from '../pages/NotFoundPage';
import OnboardingCompanySetupPage from '../pages/onboarding/CompanySetupPage';
import OnboardingSubscriptionPage from '../pages/onboarding/SubscriptionPage';
import PasswordResetPage from '../pages/PasswordResetPage';
import PendingVerificationPage from '../pages/PendingVerificationPage';
import PoolDetailsPage from '../pages/PoolDetailsPage';
import PoolFormPage from '../pages/PoolFormPage';
import PoolsPage from '../pages/PoolsPage';
import RegisterPage from '../pages/RegisterPage';
import SubscriptionCheckoutPage from '../pages/SubscriptionCheckoutPage';
import SubscriptionManagePage from '../pages/SubscriptionManagePage';
import SubscriptionExpiredPage from '../pages/SubscriptionExpiredPage';
import SubscriptionSuccessPage from '../pages/SubscriptionSuccessPage';
import VerifyEmailPage from '../pages/VerifyEmailPage';
import OnboardingRoute from './OnboardingRoute';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';

const AppRouter = () => (
  <Routes>
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <HomePage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/login"
      element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      }
    />

    <Route
      path="/forgot-password"
      element={
        <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      }
    />

    <Route
      path="/register"
      element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      }
    />

    <Route
      path="/onboarding/company"
      element={
        <OnboardingRoute step="company">
          <OnboardingCompanySetupPage />
        </OnboardingRoute>
      }
    />

    <Route
      path="/onboarding/subscription"
      element={
        <OnboardingRoute step="subscription">
          <OnboardingSubscriptionPage />
        </OnboardingRoute>
      }
    />

    <Route
      path="/subscription-expired"
      element={
        <ProtectedRoute requiresSubscription={false}>
          <SubscriptionExpiredPage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/subscription/success"
      element={
        <ProtectedRoute>
          <SubscriptionSuccessPage />
        </ProtectedRoute>
      }
    />

    <Route
      path="/subscription/checkout"
      element={
        <ProtectedRoute requiresCompany={false} requiresSubscription={false}>
          <SubscriptionCheckoutPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscription/resume"
      element={
        <ProtectedRoute requiresCompany={false} requiresSubscription={false}>
          <SubscriptionCheckoutPage resume />
        </ProtectedRoute>
      }
    />
    <Route
      path="/subscription/manage"
      element={
        <ProtectedRoute requiresSubscription={false}>
          <SubscriptionManagePage />
        </ProtectedRoute>
      }
    />

    {/* Accept invitation page */}
    <Route path="/accept-invite" element={<AcceptInvitePage />} />

    {/* Verify email page - processes the link from the email */}
    <Route path="/verify-email" element={<VerifyEmailPage />} />

    {/* Pending verification - shown when user is logged in but email not yet verified */}
    <Route
      path="/verify-email-pending"
      element={
        <ProtectedRoute
          requireEmailVerified={false}
          requiresCompany={false}
          requiresSubscription={false}
        >
          <PendingVerificationPage />
        </ProtectedRoute>
      }
    />

    {/* Password reset page */}
    <Route path="/reset-password" element={<PasswordResetPage />} />

    {/* Protected routes - require authentication */}
    {/* <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      }
    /> */}

    {featureFlags.pools && (
      <>
        <Route
          path="/pools"
          element={
            <ProtectedRoute>
              <PoolsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pools/new"
          element={
            <ProtectedRoute>
              <PoolFormPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pools/:poolId"
          element={
            <ProtectedRoute>
              <PoolDetailsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pools/:poolId/edit"
          element={
            <ProtectedRoute>
              <PoolFormPage />
            </ProtectedRoute>
          }
        />
      </>
    )}

    {/* Error page */}
    <Route path="/error" element={<ErrorPage />} />

    {/* 404 - catch all */}
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRouter;
